import { Component, Inject, OnInit } from '@angular/core';
import { CardDesignComponent } from '../../design/slide-up-card/card-design.component';
import { Overlay } from '@angular/cdk/overlay';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormValidators } from 'src/app/@forms/validators/validators';
import { POPUP_DATA } from 'src/app/@shared/services/modal/modal.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { PopUpComponent } from '../pop-up.component';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import {
  ADD_TO_CALENDAR,
  CANCEL,
  CLOSE,
  EMAIL,
  INSERT_EMAIL_ADDRESS,
  SEND,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { RoutePlanning } from 'src/app/modules/route-planner/interfaces/route-planning/@route-planning.interface';
import { finalize } from 'rxjs';

@Component({
    templateUrl: './add-calendar-pop-up.component.html',
    styleUrls: ['./add-calendar-pop-up.component.scss'],
    standalone: false
})
export class AddCalendarPopUpComponent
  extends PopUpComponent
  implements OnInit
{
  calendarForm: FormGroup<{ emailAddress: FormControl<string> }>;
  isSubmitting: boolean = false; // Flag to prevent multiple submissions

  direction: Direction;
  headerText: string;
  descText: string;
  mailText: string;
  sendText: string;
  cancelText: string;
  closeText: string;

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,

    @Inject(POPUP_DATA)
    public readonly data: { 
      route: RoutePlanning;
      originName?: string;
      destinationName?: string;
    },
    private readonly fb: FormBuilder,
    private readonly languageService: LanguageService
  ) {
    super(routePlanningService, resizeService, overlay);

    this.calendarForm = fb.group({
      emailAddress: new FormControl<string>(null, FormValidators.required),
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.headerText = ADD_TO_CALENDAR[language.language];
      this.descText = INSERT_EMAIL_ADDRESS[language.language];
      this.mailText = EMAIL[language.language];
      this.sendText = SEND[language.language];
      this.cancelText = CANCEL[language.language];
      this.closeText = CLOSE[language.language];
    });
  }

  sendEmail() {
    // Check if already submitting or form is invalid
    if (this.isSubmitting || !this.calendarForm.valid) {
      return;
    }

    // Set submitting flag to true
    this.isSubmitting = true;

    const emailAddress = this.calendarForm.value.emailAddress;
    
    // Extract origin and destination names from data or fallback to route sections
    const originName = this.data.originName || 
      this.data.route.sections?.[0]?.departure?.place?.name || '';
    const destinationName = this.data.destinationName || 
      this.data.route.sections?.[this.data.route.sections.length - 1]?.arrival?.place?.name || '';
    
    this.routePlanningService
      .addRouteToCalendar(this.data.route, emailAddress, originName, destinationName)
      .pipe(
        finalize(() => {
          // We don't need to reset the flag here as we'll either close the modal or reset on error
        })
      )
      .subscribe({
        next: () => this.closeCard(),
        error: () => {
          // Only reset isSubmitting on error to allow retry
          this.isSubmitting = false;
        },
      });
  }
}
